import React, { useCallback, useEffect, useState } from "react";
import { ReactComponent as Me } from "assets/Header/me-large.svg";
import { SideBar } from "components/SideBar";
import { IUpdateUsersProps } from "interfaces/User";
import {
  changePasswordService,
  getCurrentUser,
  getUserService,
  updateProfileService,
} from "services/UserServices";

import { IFormError } from "interfaces/ExpressError";
import { isEmailValid } from "utils/isEmailValid";
import { CheckAlert } from "utils/checkAlert";
import { PasswordTab, PaymentTab, ProfileTab, SettingsTab } from "./Tabs";
import * as S from "./styles";

export function Profile() {
  const [errors, setErrors] = useState<IFormError>({});
  const [editUser, setEditUser] = useState<IUpdateUsersProps>(
    {} as IUpdateUsersProps
  );
  const [selectedTab, setSelectedTab] = useState<string>("profile");
  const [parsed, setParsed] = useState<boolean>(false);
  const [newName, setNewName] = useState("");
  const [newCpf, setNewCpf] = useState("");
  const [newRg, setNewRg] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [showFirstPassword, setShowFirstPassword] = useState(false);
  const [showSecondPassword, setShowSecondPassword] = useState(false);
  const [showThirdPassword, setShowThirdPassword] = useState(false);
  const [email, setEmail] = useState<string>("");

  useEffect(() => {
    const stringUser = localStorage.getItem("user");

    if (stringUser) {
      const user = JSON.parse(stringUser);
      setEditUser({ ...user });
      setParsed(true);
    }
  }, []);

  const checkIfUserExist = useCallback(async () => {
    try {
      const userExist = await getUserService({ where: { email } });

      if (userExist.status && userExist.item.email !== editUser.email) {
        addError("emailExists", "E-mail já registrado");
        return;
      }
    } catch {
      removeError("emailExists");
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  useEffect(() => {
    if (isEmailValid(email)) {
      checkIfUserExist();
    }
  }, [email, checkIfUserExist]);

  function handleShowFirstPassword() {
    setShowFirstPassword(!showFirstPassword);
  }
  function handleShowSecondPassword() {
    setShowSecondPassword(!showSecondPassword);
  }
  function handleShowThirdPassword() {
    setShowThirdPassword(!showThirdPassword);
  }

  function onUpdateSubmit(event: React.SyntheticEvent) {
    event.preventDefault();

    updateProfileService({
      cpf: newCpf === "" ? editUser.cpf : newCpf,
      email: newEmail === "" ? editUser.email : newEmail,
      name: newName === "" ? editUser.name : newName,
      rg: newRg === "" ? editUser.rg : newRg,
      id: editUser.id,
    }).then(async (res) => {
      if (res.status) {
        await getCurrentUser().then((getRes) => {
          if(getRes){
          localStorage.setItem("user", JSON.stringify(getRes));
          window.location.reload();
          localStorage.setItem(
            "message",
            "Os dados do perfil foram salvos corretamente."
          );
          window.location.reload();}
        });
      }
    });
  }

  useEffect(() => {
    CheckAlert();
  }, []);

  function changePasswordSubmit(event: React.SyntheticEvent) {
    event.preventDefault();
    if (verifyPassword === newPassword)
      changePasswordService({ newPassword, password:oldPassword })
        .then((res) => {
          window.location.reload();
        })
        .catch((err) => {
          console.log(err.response);
        });
  }

  function addError(field: string, message: string) {
    const _errors = { ...errors };
    _errors[field] = message;

    setErrors(() => {
      return _errors;
    });
  }

  function removeError(field: string) {
    const _errors = { ...errors };
    delete _errors[field];

    setErrors(() => {
      return _errors;
    });
  }

  return (
    <S.ProfileContentContainer>
      <SideBar />
      <S.ProfileContainer>
        <div className="profile-menu-wrapper">
          <h1>Meu perfil</h1>

          <S.UserInfo>
            <Me />
            <h2>{editUser?.name}</h2>
          </S.UserInfo>
          <S.ProfileActiveButton
            active={selectedTab === "profile"}
            onClick={() => {
              setSelectedTab("profile");
            }}
          >
            Meus dados
          </S.ProfileActiveButton>
          <S.ProfileActiveButton
            active={selectedTab === "password"}
            onClick={() => {
              setSelectedTab("password");
            }}
          >
            Trocar senha
          </S.ProfileActiveButton>
          <S.ProfileActiveButton
            active={selectedTab === "settings"}
            onClick={() => {
              setSelectedTab("settings");
            }}
          >
            Customizar plataforma
          </S.ProfileActiveButton>
          <S.ProfileActiveButton
            active={selectedTab === "payment"}
            onClick={() => {
              setSelectedTab("payment");
            }}
          >
            Editar dados de pagamento
          </S.ProfileActiveButton>
        </div>
        {selectedTab === "profile" && editUser && (
          <ProfileTab
            addError={addError}
            editUser={editUser}
            errors={errors}
            onUpdateSubmit={onUpdateSubmit}
            parsed={parsed}
            removeError={removeError}
            setEmail={setEmail}
            setNewCpf={setNewCpf}
            setNewEmail={setNewEmail}
            setNewName={setNewName}
            setNewRg={setNewRg}
          />
        )}
        {selectedTab === "password" && (
          <PasswordTab
            changePasswordSubmit={changePasswordSubmit}
            handleShowFirstPassword={handleShowFirstPassword}
            handleShowSecondPassword={handleShowSecondPassword}
            handleShowThirdPassword={handleShowThirdPassword}
            setNewPassword={setNewPassword}
            setOldPassword={setOldPassword}
            setVerifyPassword={setVerifyPassword}
            showFirstPassword={showFirstPassword}
            showSecondPassword={showSecondPassword}
            showThirdPassword={showThirdPassword}
          />
        )}
        {selectedTab === "settings" && <SettingsTab />}
        {selectedTab === "payment" && <PaymentTab />}
      </S.ProfileContainer>
    </S.ProfileContentContainer>
  );
}
